import FilterLabel from "./filter-label";

interface SelectedSubjectsLabelsProps {
    selectedCourses: Set<string>;
    reviewSubjects: any;
    onRemove: (catCode: string) => void;
}

const SelectedSubjectsLabels = ({ selectedCourses, reviewSubjects, onRemove }: SelectedSubjectsLabelsProps) => {
    if (selectedCourses.size === 0) return null;

    return (
        <div className="flex flex-wrap gap-[8px]">
            {Array.from(selectedCourses).map((catCode) => {
                const subject = reviewSubjects?.subjects?.find((s: any) => s.catCode === catCode);
                return (
                    <FilterLabel
                        key={catCode}
                        label={subject?.description || catCode}
                        onRemove={() => onRemove(catCode)}
                    />
                );
            })}
        </div>
    );
};

export default SelectedSubjectsLabels;
